<template>
  <Modal v-bind:open="this.openModal" @close="this.closeModal">
    <form>
      <div class="space-y-4">
        <FormField id="name" label="Name" name="name" placeholder="Name" v-model="organization.name" />
        <FormField
          id="business_name"
          label="Business name"
          name="business_name"
          placeholder="Business name"
          v-model="organization.businessName"
        />
        <FormField
          id="billing_address"
          label="Adresse de facturation"
          name="billing_address"
          placeholder="Billing address"
          v-model="organization.billingAddress"
        />
        <FormField
          id="registration_number"
          label="Registration number"
          name="registration_number"
          placeholder="Registration number"
          v-model="organization.registrationNumber"
        />
        <FormField
          id="total_points_of_sale"
          label="Total points of sale"
          name="total_points_of_sale"
          placeholder="Total points of sale"
          v-model="organization.totalPointsOfSale"
        />
        <FormField
          id="logo_url"
          label="Logo url"
          name="logo_url"
          placeholder="Logo url"
          v-model="organization.logoUrl"
        />
        <Selector
          id="invoice_level"
          label="Invoice Level"
          name="invoice_level"
          v-model="organization.invoiceLevel"
          :options="invoiceLevelOptions"
        />
        <Selector
          id="revenue_range"
          label="Revenue range"
          name="revenue_range"
          v-model="organization.revenueRange"
          :options="revenueRangeOptions"
        />
        <Selector
          id="network_type"
          label="Network type"
          name="network_type"
          v-model="organization.networkType"
          :options="networkTypeOptions"
        />
      </div>
      <div class="mt-6 flex items-center justify-end gap-x-6">
        <button type="button" class="text-sm font-semibold leading-6 text-gray-900" @click="this.closeModal">
          Annuler
        </button>
        <div
          type="submit"
          class="cursor-pointer rounded-md px-3 py-2 text-sm font-semibold text-button-font-primary bg-primary uppercase shadow-xs"
          @click="createOrganization"
        >
          Créer
        </div>
      </div>
    </form>
  </Modal>
</template>

<script>
import { FormField } from "@estaly/ui";
import { Selector, Modal } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    Modal,
    Selector,
    FormField,
  },
  props: ["openModal"],

  data() {
    return {
      organization: {
        name: "",
        businessName: "",
        billingAddress: "",
        networkType: "",
        revenueRange: "",
        registrationNumber: "",
        totalPointsOfSale: "",
        invoiceLevel: "",
        logoUrl: "",
      },
    };
  },

  computed: {
    ...mapGetters("organizations", ["invoiceLevels", "revenueRanges", "networkTypes"]),

    invoiceLevelOptions() {
      return this.invoiceLevels().map((invoiceLevel) => ({
        value: invoiceLevel,
        label: this.$t(`organization.invoice_level.${invoiceLevel}`),
      }));
    },

    revenueRangeOptions() {
      return this.revenueRanges().map((revenueRange) => ({
        value: revenueRange,
        label: this.$t(`organization.revenue_range.${revenueRange}`),
      }));
    },

    networkTypeOptions() {
      return this.networkTypes().map((networkType) => ({
        value: networkType,
        label: this.$t(`organization.network_type.${networkType}`),
      }));
    },
  },

  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("organizations", ["create"]),

    closeModal: function () {
      this.$emit("close");
    },

    createOrganization: async function () {
      const response = await this.create({ ...this.organization });
      if (!response?.success) return;

      this.$router.push(`/organizations/${response.data.organization.id}`);

      this.notify({
        category: "simple",
        type: "success",
        title: "L'organisation est crée.",
      });
      this.closeModal();
    },
  },
};
</script>
